import { createTheme, responsiveFontSizes } from '@mui/material/styles';
import MuiCssBaseline from './MuiCssBaseline';
import palette from './palette';
import MuiAppBar from './MuiAppBar';
import {Moduletheme} from './Moduletheme';

const theme = createTheme({
  palette,
  Moduletheme,
  components: {
    MuiCssBaseline,
    MuiAppBar,
    
  }
});

console.log(theme);

export default responsiveFontSizes(theme);
